export const RESTRICTIONS = 'restrictions'

export enum RestrictionsMap {
  MAX_USAGE = 'maxUsage',
  MAX_USAGE_PER_CLIENT = 'maxUsagePerClient',
  MAX_ITEMS_PER_CART = 'maxItemsPerCart',
  MAX_ITEMS_PER_ATTRIBUTE = 'maxItemsPerAttribute',
}

export enum ApplyTo {
  cheapest = 'cheapest',
  mostExpensive = 'mostExpensive',
}
